export const WINDOW_SHOULD_SCROLL_MESSAGE = 'SLED.windowScroll.shouldScroll';

// In the future we need to also pass an identifier for the workbook - given
// the documentScrollHeight is only used on Flight mobile and mobile only
// displays 1 document at once currently, this isn't necessary yet,
// but will be if we expand the use case to having 2+ documents displayed.
export function postDocumentScrollHeightMessage() {
  window.parent.postMessage(
    {
      type: 'SLED.documentScrollHeight.resize',
      documentScrollHeight: document.body.scrollHeight,
    },
    '*'
  );
}

export function postWindowScrollMessage(documentId) {
  window.parent.postMessage(
    {
      type: 'SLED.windowScroll.didScroll',
      documentId,
      windowScrollX: window.scrollX,
      windowScrollY: window.scrollY,
    },
    '*'
  );
}

export function postPresentationModeConnectMessage(documentId) {
  window.parent.postMessage(
    {
      type: 'SLED.presentationMode.connect',
      documentId,
    },
    '*'
  );
}
